import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { ProduitService } from '../../../@core/data/rest/produit/produit-service';
import { PartenaireService } from '../../../@core/data/rest/partenaire/partenaire-service';
import { SharedMethods } from '../../../util/sharedMethods-service';
import { Validator } from '../../../@core/data/model/validator';
import { Produit } from '../../../@core/data/model/produit';
import { Partenaire } from '../../../@core/data/model/partenaire';
import { PartenaireFormComponent } from '../../partenaire/partenaireform/partenaireform.component';
import { isDefined } from '@angular/compiler/src/util';
import { plainToClass } from 'class-transformer';
import { CatProduitService } from '../../../@core/data/rest/catproduit/catproduit-service';
import { AuthService } from '../../../auth/auth.service';
import swal from 'sweetalert2';
import { CatProduit } from '../../../@core/data/model/catproduit';
import { ApiFile } from '../../../@core/data/model/apifile';

// importation script ckeditor
import '../../ckeditor.loader';
import 'ckeditor';
import { CatFormComponent } from '../catform/catform.component';
import { Config } from '../../../config/config';
import { ApiUtils } from '../../../@core/data/rest/ApiUtils';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'nb-produit',
  templateUrl: './produitform.component.html' ,
  styleUrls: ['./produitform.component.scss'],
})
export class ProduitFormComponent implements OnInit {

  @Input() produitEdit: Produit;

  selectedItems = [];
  dropdownSettings = {};

  selectedItemsCat = [];
  dropdownSettingsCat = {};

  selectedItemsEmballage = [];
  dropdownSettingsEmballage = {};

  @Input() isAddImage = false;

  selectedCamera: any;

  isSingleView = false;

  ckeditorconfig = {};

  constructor(
      protected dialogRef: NbDialogRef<ProduitFormComponent>,
      public authService: AuthService,
      public produitService: ProduitService,
      public partenaireService: PartenaireService,
      public sharedMethods: SharedMethods,
      private dialogService: NbDialogService,
      public cdRef: ChangeDetectorRef,
      public catProduitService: CatProduitService,
      private apiUtils: ApiUtils,
  ) {


    this.ckeditorconfig = {
      filebrowserBrowseUrl: Config.urlserveur + Config.urlmediatheque + '?mime=all' + '&sousdossier=' + this.apiUtils.TENANTDB,
      filebrowserImageBrowseUrl: Config.urlserveur + Config.urlmediatheque + '?mime=image' + '&sousdossier=' + this.apiUtils.TENANTDB,
      removeDialogTabs: 'link:upload;image:upload',
      height: '300',
    }


  }

  ngOnInit(): void {


    // console.log(this.produitService.defaultfournisseur);

    if(this.produitService.defaultfournisseur !== undefined) {

      if(this.produitEdit.fournisseurs === undefined || this.produitEdit.fournisseurs === null)
      this.produitEdit.fournisseurs = [];

      this.produitEdit.fournisseurs.push(this.produitService.defaultfournisseur);

    }


    this.authService.logoutEvent.subscribe(() => {

      this.dialogRef.close();

    });

    this.dropdownSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'nom',
        selectAllText: 'Selectionner tout',
        unSelectAllText: 'Déselectionner tout',
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: 'recherche',
        noDataAvailablePlaceholderText: 'Aucune donnée trouvée',
        closeDropDownOnSelection: true,
    };


    this.dropdownSettingsCat = {
        singleSelection: false,
        idField: 'id',
        textField: 'chemin',
        // textField: 'nom',
        selectAllText: 'Selectionner tout',
        unSelectAllText: 'Déselectionner tout',
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: 'recherche',
        noDataAvailablePlaceholderText: 'Aucune donnée trouvée',
        closeDropDownOnSelection: true,
    };

    this.dropdownSettingsEmballage = {
        singleSelection: true,
        idField: 'id',
        textField: 'designation',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: 'recherche',
        noDataAvailablePlaceholderText: 'Aucune donnée trouvée',
        closeDropDownOnSelection: true,
    };

     

      // chargement des familles
      if (this.catProduitService.catproduits === undefined) {

        // this.cdRef.detectChanges();
        this.catProduitService.getCats().then( familles => {

        });

     }

     if (this.produitEdit.categories !== undefined && this.produitEdit.categories !== null) {
          this.selectedItemsCat = this.produitEdit.categories;
     }

     if (this.produitEdit.emballage !== undefined) {
      this.selectedItemsEmballage = [this.produitEdit.emballage];
     }

  }


  onItemSelect(item: any) {
    
    if ( this.produitEdit.fournisseurs !== undefined && this.produitEdit.fournisseurs !== null) {

      let itemIndex: number;
      itemIndex = this.produitEdit.fournisseurs.findIndex(itm => itm.id === item.id);

      if (itemIndex === -1)
      this.produitEdit.fournisseurs.push(item);

    } else {

      this.produitEdit.fournisseurs = [];
      this.produitEdit.fournisseurs.push(item);

    }



  }

  onSelectAll(items) {

    // const fours = plainToClass( Partenaire, items);

    this.produitEdit.fournisseurs = items;

  }

  onDeSelectAll(event) {
    this.produitEdit.fournisseurs = [];
  }

  onDeSelect(item: any) {
    let itemIndex: number;
    itemIndex = this.produitEdit.fournisseurs.findIndex(itm => itm.id === item.id);

    if (itemIndex > -1)
    this.produitEdit.fournisseurs.splice(itemIndex, 1);
  }


  // evenment famille dropdown

  onItemSelectCat(item: any) {

    /* if ( this.produitEdit.categories !== undefined && this.produitEdit.categories !== null) {

      let itemIndex: number;
      itemIndex = this.produitEdit.categories.findIndex(itm => itm.id === item.id);

      if (itemIndex === -1)
      this.produitEdit.categories.push(item);

    } else {

      this.produitEdit.categories = [];
      this.produitEdit.categories.push(item);

    } */

    

    //this.produitEdit.categories = [];

    if(!this.produitEdit.categories)
    this.produitEdit.categories = [];

    this.produitEdit.categories.push(item);

    console.log(this.produitEdit.categories)


  }

  onSelectAllCat(items) {

    this.produitEdit.categories = items;

  }

  onDeSelectAllCat(event) {
    this.produitEdit.categories = [];
  }

  onDeSelectCat(item: any) {
    let itemIndex: number;
    itemIndex = this.produitEdit.categories.findIndex(itm => itm.id === item.id);

    if (itemIndex > -1)
    this.produitEdit.categories.splice(itemIndex, 1); 
    // this.produitEdit.categories = [];
  }




  // evenement emballage

  onItemSelectEmballage(item: any) {
    // tslint:disable-next-line:no-console
    /* for ( let i = 0; i < this.partenaireService.getLocalPartner(this.typePartner).length; i++) {
      if (this.partenaireService.getLocalPartner(this.typePartner)[i].id === item.item_id ) {
        this.facture.partenaire = this.partenaireService.getLocalPartner(this.typePartner)[i];
      }
    } */
    this.produitEdit.emballage = item;
  }

  onDeSelectEmballage(item: any) {
    this.produitEdit.emballage = null;
  }

  addpartner() {
    const partner = new Partenaire;
    this.editPartner(partner, 'add', 'fournisseur', 'Fournisseur');
  }

  editPartner(partner: Partenaire, typeEdit: string, typePartenaire: string, labelPartner: string) {

      const closeOnBackdropClick = false;
      this.dialogService.open(PartenaireFormComponent, {
        closeOnBackdropClick,
        context: {
          partenaireEdit : partner,
          typePartenaire : typePartenaire,
          labelPartner: labelPartner,
        },
      }).onClose.subscribe(data => {

          if ( data !== undefined) {

            // on met à jour la partenaire de la facture et le partenaire selectionner
            if ( this.produitEdit.fournisseurs !== undefined && this.produitEdit.fournisseurs !== undefined !== null)
            this.produitEdit.fournisseurs.push(data);
            else
            this.produitEdit.fournisseurs = [data];

            this.selectedItems = this.produitEdit.fournisseurs;

           /* if (typeEdit === 'update' )
            this.sourceReglement.update(this.reglementEdit, data);

            if (typeEdit === 'add' )
            this.sourceReglement.prepend(data); */

          }
      });
  }

  toggleEmballageDirection(newDirection) {
    // this.directionService.setDirection(newDirection);
    // tslint:disable-next-line:no-console
    // console.log(newDirection);
    this.produitEdit.is_emballage = newDirection;

    // on supprime l'emballage au cas le produit avait d'emballage
    if (newDirection) {
      this.produitEdit.emballage = undefined;
      this.selectedItemsEmballage = [];
    }

   }

   toggleStockableDirection (newDirection) {

      this.produitEdit.is_stockable = newDirection;

   }

   toggleNatureDirection (newDirection) {

      this.produitEdit.nature = newDirection;

   }

   toggleActivateOrderDirection(newDirection) {

    this.produitEdit.is_publish = newDirection;

   }

   toggleSellInLigneDirection(newDirection) {

    this.produitEdit.sell_in_ligne = newDirection;

   }

   toggleexternaLinkDirection(newDirection) {
    this.produitEdit.is_external_link  = newDirection;  
   }

   toggleIsPromoDirection(newDirection) {
    this.produitEdit.is_promo = newDirection;
   }

   typeCalculTvaVentetoggleDirection(newDirection) {
    this.produitEdit.type_calcul_tva_vente = newDirection;
   }

   typeCalculTvaAchattoggleDirection(newDirection) {
    this.produitEdit.type_calcul_tva_achat = newDirection;
   }


  cancel() {
    if (this.produitService.iSconnecting === false) {
        this.dialogRef.close();
    }
  }

  submit() {
    // alert(JSON.stringify(this.produitEdit));
    // alert('nature: ' + this.reglementEdit.nature_reglement + ' montant: ' + this.reglementEdit.montant.toString());
    // this.dialogRef.close();

    // this.reglementEdit.date_flux = this.sharedMethods.converNgbDateStructToString(this.dateReglement);

    let valid: Validator;
    valid = this.sharedMethods.validateProduit(this.produitEdit, this.produitService.produits);

    if (valid.result) {

        // this.dialogRef.close(this.partenaireEdit);

        if (this.produitService.iSconnecting === false) {

            // tslint:disable-next-line:no-console
            console.log(this.produitEdit);

            this.produitService.saveProduit(this.produitEdit).then( produit => {

                /* this.produitEdit.id = produit.id;
                this.dialogRef.close(this.produitEdit); */

                this.dialogRef.close(plainToClass(Produit, produit as Object));
                // alert(JSON.stringify(this.fluxstockedit));

            }, (err) => {

                this.sharedMethods.errorApiShow(err.error.code, err.error.message);

            });
        }

    } else {

        this.sharedMethods.toastShow('error', valid.title, valid.message);

    }


 }

 addFamily() {

  const cat = new CatProduit;
  
  this.editCat(cat, 'add');

 }

 editCat(cat: CatProduit, typeEdit: string) {


  const catRacine =  undefined;

  /* if (this.route.snapshot.params['typeCompte'] !== 'all') {

    compteRacine = this.compteRacine;

  } */

  const closeOnBackdropClick = false;
  this.dialogService.open(CatFormComponent, {
    closeOnBackdropClick,
    context: {
      catEdit : cat,
      catRacine: catRacine,
      // typeCompte: this.route.snapshot.params['typeCompte'],
    },
  }).onClose.subscribe(data => {

      if ( data !== undefined) {

        this.selectedItemsCat = [
          data,
        ];

        this.produitEdit.categories = [
          plainToClass(CatProduit, data as object),
        ];

      }

  });

}

 onFileInput(event) {

    if ( event.target.files[0] === undefined)
    return;

    // this.fichierName = this.selectedFile.name;
    const tr = 'fvfbb'

    if ( /\.(jpg||jpeg||png)$/i.test(event.target.files[0].name.toLowerCase())) {

      console.log(event.target.files[0]);
      /* const reader = new FileReader();
      this.imagePath = event.target.files;
      reader.readAsDataURL(event.target.files[0]);
      const th = this;
      reader.onload = (_event) => {
        th.imgURL = reader.result;
      }; */

      this.produitService.addImage(this.produitEdit.id, event.target.files).then( images => {
        
        if(this.produitEdit.images === null || this.produitEdit.images === undefined)
        this.produitEdit.images = [];

        images.forEach( elem => {
          this.produitEdit.images.unshift(elem);
        })


        // definir comme image principale par défaut
        if(this.produitEdit.image_principale === null || this.produitEdit.image_principale === undefined)
        this.produitEdit.image_principale = images[0];

      })

    } else {

      this.sharedMethods.toastShow( 'error', 'Fichier  incorrect', "vous devez choisir les fichiers jpg, jpeg ou png dont la taille est inférieur 2Mo");

    }

 }

 onFileInputFichier(event) {

  if ( event.target.files[0] === undefined)
  return;

  // this.fichierName = this.selectedFile.name;
  const tr = 'fvfbb'

  console.log(event.target.files[0]);
  /* const reader = new FileReader();
  this.imagePath = event.target.files;
  reader.readAsDataURL(event.target.files[0]);
  const th = this;
  reader.onload = (_event) => {
    th.imgURL = reader.result;
  }; */

  this.produitService.addFichier(this.produitEdit.id, event.target.files[0], this.isAddImage).then( fichier => {
    
    // definir comme image principale par défaut
    this.produitEdit.fichier_telechargeable = fichier;


  })


}

 selectCamera(camera: any) {
    this.selectedCamera = camera;
    this.isSingleView = true;
 }

 changeMainImage(img: ApiFile) {
   this.produitEdit.image_principale = img;
 }

 deleteImage(img: ApiFile) {

  const index = this.produitEdit.images.findIndex(item =>item.id === img.id);
  const saveId = this.produitEdit.images[index].id;
  this.produitEdit.images[index].id = undefined;

  if(this.produitEdit.image_principale !== undefined && this.produitEdit.image_principale !== null && this.produitEdit.image_principale.id === saveId)
  this.produitEdit.image_principale = null;

  this.produitService.deleteImage( this.produitEdit.id, saveId).then( data => {
    this.produitEdit.images.splice(index, 1);
  });

  // this.produitEdit.images.splice(index, 1);

 }


}
